import { Link } from 'react-router-dom';
import { categories, hotComics, latestUpdates } from '@/mocks/comics';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20warm%20amber%20and%20coral%20gradient%20background%20with%20subtle%20comic%20panel%20texture%20lines%2C%20minimalist%20artistic%20design%2C%20soft%20flowing%20shapes%2C%20elegant%20warm%20color%20palette%2C%20no%20text%2C%20dreamy%20atmosphere%2C%20clean%20aesthetic%2C%20suitable%20for%20hero%20banner&width=1600&height=900&seq=hero-bg-comic&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-center"
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-7xl mx-auto text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-5 leading-tight">
          下拉式漫画免费看
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          43423漫画网提供<strong>下拉式漫画免费阅读</strong>，支持漫画下拉式上下滑动浏览，
          <strong>韩漫下拉式</strong>、<strong>日漫下拉式</strong>等<strong>下拉式漫画大全</strong>，
          好看的漫画下拉式在线看，流畅阅读体验。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <Link
            to="/category/all"
            className="px-7 py-3 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-all duration-300 text-sm whitespace-nowrap cursor-pointer"
          >
            立即阅读
          </Link>
          <Link
            to="/category/korean"
            className="px-7 py-3 bg-white/15 text-white font-medium rounded-lg hover:bg-white/25 transition-all duration-300 text-sm backdrop-blur-sm whitespace-nowrap cursor-pointer"
          >
            韩漫推荐
          </Link>
        </div>

        <div className="flex items-center justify-center gap-2 flex-wrap">
          {categories.filter((c) => c.slug !== 'all').slice(0, 6).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="px-3.5 py-2 bg-white/10 backdrop-blur-sm text-white/80 text-xs rounded-full hover:bg-white/20 hover:text-white transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export function PopularSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              下拉式漫画大全，好看的漫画下拉式在线看
            </p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
          {hotComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 下拉式漫画免费看`}
                  title={`${comic.title} - 下拉式漫画在线阅读`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-primary-500 text-white whitespace-nowrap">
                    {comic.status}
                  </span>
                </div>
                <div className="absolute top-2 right-2 flex items-center gap-1 bg-background-950/70 backdrop-blur-sm px-2 py-0.5 rounded-md">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-star-fill text-xs text-primary-400"></i>
                  </span>
                  <span className="text-xs text-white font-medium">{comic.rating}</span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors truncate font-heading">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 truncate">{comic.author}</p>
                <div className="flex items-center gap-1.5 mt-2 flex-wrap">
                  {comic.tags.slice(0, 2).map((tag) => (
                    <span key={tag} className="px-1.5 py-0.5 text-[10px] rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export function LatestSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              漫画下拉式阅读，实时追更不等待
            </p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            更多更新
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-product-shop>
          {latestUpdates.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-20 h-28 flex-shrink-0 rounded-md overflow-hidden">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 下拉式漫画`}
                  title={`${comic.title} - 漫画下拉式阅读`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex flex-col justify-between min-w-0 flex-1">
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors truncate font-heading">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 truncate">{comic.author}</p>
                  <div className="flex items-center gap-1.5 mt-2 flex-wrap">
                    {comic.tags.slice(0, 2).map((tag) => (
                      <span key={tag} className="px-1.5 py-0.5 text-[10px] rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="flex items-center justify-between mt-2">
                  <span className="text-[11px] text-foreground-400">
                    更新至 {comic.chapters.length} 话
                  </span>
                  <span className="text-[11px] text-accent-600 font-medium">
                    {comic.updateTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CategoryTagsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
          漫画分类导航
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          下拉式漫画大全，总有一款适合你
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
              className="flex items-center gap-3 px-4 py-4 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer group"
            >
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all">
                <i className={`${cat.icon} text-base`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export function StatsSection() {
  const stats = [
    { value: '5000+', label: '漫画资源', icon: 'ri-book-2-line' },
    { value: '200万+', label: '活跃读者', icon: 'ri-user-heart-line' },
    { value: '99.9%', label: '服务稳定性', icon: 'ri-shield-check-line' },
    { value: '24h', label: '更新保障', icon: 'ri-time-line' },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-16 bg-accent-500">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center text-white">
              <div className="w-12 h-12 mx-auto flex items-center justify-center mb-3">
                <i className={`${stat.icon} text-2xl text-white/90`}></i>
              </div>
              <p className="text-3xl md:text-4xl font-heading font-bold">{stat.value}</p>
              <p className="text-sm text-white/80 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FAQSection() {
  const faqs = [
    {
      q: '什么是下拉式漫画？',
      a: '下拉式漫画是一种新型的漫画阅读方式，区别于传统的左右翻页模式，下拉式漫画采用上下滑动浏览的方式，读者只需要用手指或鼠标向下滑动，就可以连续不断地阅读漫画内容，阅读体验更加流畅自然，特别适合手机端的漫画阅读。',
    },
    {
      q: '43423漫画网的漫画都是免费的吗？',
      a: '是的，43423漫画网上的所有漫画资源均为免费提供。我们致力于为广大漫画爱好者打造一个优质的免费下拉式漫画阅读平台，让每一位读者都能畅享漫画下拉式阅读的乐趣。',
    },
    {
      q: '支持哪些类型的漫画？',
      a: '43423漫画网提供丰富的漫画类型，包括韩漫下拉式、日漫下拉式、恋爱、热血、奇幻、搞笑、悬疑、校园、都市等多种分类。无论你喜欢什么风格，都能在这里找到心仪的漫画。',
    },
    {
      q: '如何快速找到想看的漫画？',
      a: '你可以通过首页的分类导航快速找到感兴趣的类型，也可以使用搜索功能输入漫画名称查找。我们还会定期更新热门推荐和最新更新列表，帮助你发现更多好看的漫画。',
    },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-16 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          关于下拉式漫画阅读的常见疑问解答
        </p>
        <div className="flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden cursor-pointer"
            >
              <summary className="px-5 py-4 text-sm font-medium text-foreground-900 flex items-center justify-between list-none">
                <span>{faq.q}</span>
                <span className="w-5 h-5 flex items-center justify-center transition-transform group-open:rotate-180">
                  <i className="ri-arrow-down-s-line text-lg text-foreground-500"></i>
                </span>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}